import React, { Component } from "react";
import "../../styles/FullscreenDialog.css";
import close from "../../img/close_black.svg";
import Closeable from "./Closeable";

export interface FullscreenDialogProps {
  onRequestClose?: () => void;
  onClose?: () => void;
  interactive?: boolean;
}

export default class FullscreenDialog extends Component<FullscreenDialogProps> {
  constructor(props: any) {
    super(props);

    this.requestClose = this.requestClose.bind(this);
  }

  componentDidMount() {
    document.body.classList.add("no-sroll")
  }

  componentWillUnmount() {
    document.body.classList.remove("no-sroll")

    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  requestClose() {
    const onRequestClose = this.props.onRequestClose;

    if (onRequestClose) {
      onRequestClose();
    }
  }

  render() {
    return (
      <Closeable onClickOutside={this.requestClose} onEscape={this.requestClose}>
        <div className={"fs-dialog"}>
          {this.props.interactive ? <button className={"fs-dialog__close"} onClick={this.requestClose} autoFocus>
            <img src={close} />
            <span className={"visuallyHidden"}>Close</span>
          </button> : ""}
          {this.props.children}
        </div>
      </Closeable>
    )
  }
}
